// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3B8dh","noInteraction":"EventWrapper_noInteraction__26_CL"};